export default [{
  date_event_filed: '01/27/2012',
  date_terminated: null,
  modified: '2018-07-11 10:33:07.273226+00',
  event_name: 'Preliminary Hearing',
  hearing_judge: 'Marlar, James M.',
  date_due_set: '05/02/2012',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024075940',
  doc_no: '48',
  date_satisfied: null,
},
{
  doc_no: '49',
  date_satisfied: null,
  modified: '2018-07-11 10:33:07.242249+00',
  date_terminated: null,
  date_event_filed: '02/10/2012',
  date_due_set: '04/04/2012',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024076535',
  hearing_judge: 'Marlar, James M.',
  event_name: 'Preliminary Hearing',
},
{
  date_satisfied: null,
  doc_no: '47',
  date_due_set: '12/15/2011',
  doc_uri: null,
  hearing_judge: 'Marlar, James M.',
  event_name: 'Preliminary Hearing',
  modified: '2018-07-11 10:33:07.222524+00',
  date_terminated: null,
  date_event_filed: '11/21/2011',
},
{
  date_satisfied: null,
  doc_no: '45',
  date_due_set: '12/15/2009',
  doc_uri: null,
  hearing_judge: 'Marlar, James M.',
  event_name: 'Hrg on Motion',
  modified: '2018-07-11 10:33:07.192612+00',
  date_terminated: null,
  date_event_filed: '12/22/2009',
},
{
  date_satisfied: null,
  doc_no: '44',
  doc_uri: null,
  date_due_set: '12/15/2009',
  hearing_judge: 'Marlar, James M.',
  event_name: 'Hearing',
  date_terminated: null,
  modified: '2018-07-11 10:33:07.177026+00',
  date_event_filed: '12/22/2009',
},
{
  date_due_set: '03/26/2009',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024032146',
  event_name: 'Status Hearing',
  hearing_judge: 'Marlar, James M.',
  modified: '2018-07-11 10:33:07.163592+00',
  date_terminated: null,
  date_event_filed: '02/17/2009',
  date_satisfied: null,
  doc_no: '40',
},
{
  doc_no: '37',
  date_satisfied: null,
  date_terminated: null,
  modified: '2018-07-11 10:33:07.137973+00',
  date_event_filed: '08/25/2008',
  date_due_set: '08/29/2008',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024028619',
  event_name: 'Status Hearing',
  hearing_judge: 'Marlar, James M.',
},
{
  date_satisfied: null,
  doc_no: '39',
  date_event_filed: '08/26/2008',
  date_terminated: null,
  modified: '2018-07-11 10:33:07.1193+00',
  event_name: 'Status Hearing',
  hearing_judge: 'Marlar, James M.',
  date_due_set: '08/28/2008',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024028691',
},
{
  doc_no: '38',
  date_satisfied: null,
  date_due_set: '08/28/2008',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024028623',
  hearing_judge: 'Marlar, James M.',
  event_name: 'Status Hearing',
  modified: '2018-07-11 10:33:07.087783+00',
  date_terminated: null,
  date_event_filed: '08/25/2008',
},
{
  doc_no: '2',
  date_satisfied: null,
  date_due_set: '10/31/2007',
  doc_uri: null,
  event_name: '341 Meeting',
  hearing_judge: '',
  modified: '2018-07-11 10:33:07.059562+00',
  date_terminated: null,
  date_event_filed: '02/19/2007',
},
{
  date_terminated: null,
  modified: '2018-07-11 10:33:07.035109+00',
  date_event_filed: '05/21/2007',
  doc_uri: null,
  date_due_set: '10/18/2007',
  event_name: 'Final Filing Fee Installment',
  hearing_judge: '',
  doc_no: '22',
  date_satisfied: null,
},
{
  date_terminated: null,
  modified: '2018-07-11 10:33:07.012086+00',
  date_event_filed: '05/21/2007',
  doc_uri: null,
  date_due_set: '09/04/2007',
  hearing_judge: '',
  event_name: 'Third Filing Fee Installment',
  doc_no: '22',
  date_satisfied: null,
},
{
  date_satisfied: null,
  doc_no: '15',
  modified: '2018-07-11 10:33:06.980146+00',
  date_terminated: '05/21/2007',
  date_event_filed: '04/02/2007',
  date_due_set: '08/30/2007',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02402529',
  hearing_judge: '',
  event_name: 'Final Filing Fee Installment',
},
{
  doc_no: '15',
  date_satisfied: null,
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02402529',
  date_due_set: '07/31/2007',
  hearing_judge: '',
  event_name: 'Third Filing Fee Installment',
  modified: '2018-07-11 10:33:06.955655+00',
  date_terminated: '05/21/2007',
  date_event_filed: '04/02/2007',
},
{
  date_event_filed: '07/02/2007',
  date_terminated: null,
  modified: '2018-07-11 10:33:06.92921+00',
  event_name: 'Conversion Filing Fee Due Date',
  hearing_judge: '',
  date_due_set: '07/23/2007',
  doc_uri: null,
  date_satisfied: null,
  doc_no: '27',
},
{
  date_event_filed: '07/02/2007',
  date_terminated: null,
  modified: '2018-07-11 10:33:06.903902+00',
  hearing_judge: '',
  event_name: 'Conversion Filing Fee Due Date',
  date_due_set: '07/23/2007',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02409341',
  date_satisfied: null,
  doc_no: '26',
},
{
  date_event_filed: '05/21/2007',
  modified: '2018-07-11 10:33:06.876369+00',
  date_terminated: null,
  hearing_judge: '',
  event_name: 'Second Filing Fee Installment',
  date_due_set: '07/20/2007',
  doc_uri: null,
  date_satisfied: null,
  doc_no: '22',
},
{
  date_event_filed: '04/02/2007',
  date_terminated: '05/21/2007',
  modified: '2018-07-11 10:33:06.864278+00',
  event_name: 'Second Filing Fee Installment',
  hearing_judge: '',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02402529',
  date_due_set: '07/02/2007',
  doc_no: '15',
  date_satisfied: null,
},
{
  date_satisfied: null,
  doc_no: '22',
  date_terminated: null,
  modified: '2018-07-11 10:33:06.843588+00',
  date_event_filed: '05/21/2007',
  doc_uri: null,
  date_due_set: '06/05/2007',
  hearing_judge: '',
  event_name: 'Minimum 50.00 Fee',
},
{
  hearing_judge: '',
  event_name: 'First Filing Fee Installment',
  date_due_set: '06/01/2007',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02402529',
  date_event_filed: '04/02/2007',
  date_terminated: null,
  modified: '2018-07-11 10:33:06.83199+00',
  doc_no: '15',
  date_satisfied: null,
},
{
  date_due_set: '04/13/2007',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/02402356',
  hearing_judge: '',
  event_name: 'Objection/Response Due',
  date_terminated: null,
  modified: '2018-07-11 10:33:06.806704+00',
  date_event_filed: '03/29/2007',
  doc_no: '13',
  date_satisfied: null,
},
{
  date_terminated: null,
  modified: '2018-07-11 10:33:06.782902+00',
  date_event_filed: '02/19/2007',
  doc_uri: 'https://ecf-test.azb.uscourts.gov/doc2/024025013',
  date_due_set: '03/12/2007',
  event_name: 'Declaration ECF Petition',
  hearing_judge: '',
  doc_no: '1',
  date_satisfied: null,
},
];



// WEBPACK FOOTER //
// ./src/components/case/deadlines/deadlineArray.js